import { API_ROUTE_ADMIN_EMPLOYEE_CONSENT_COST_OBJECT_HISTORY } from '@/resources/api-routes'
import { get } from '@/util/auth'

type ConsentHistoryPerCostObject = {
  id: number
  employeeConsentId: number
  costObjectId: number
  type: 'accepted' | 'revoked'
  eventBy: string | null
  remarks: string | null
  createdAt: string
  updatedAt: string
}[]

const IS_NEW_BACKEND_API = true

export async function getConsentHistoryPerCostObject(consentId: number, costObjectId: number) {
  return get<ConsentHistoryPerCostObject>(
    API_ROUTE_ADMIN_EMPLOYEE_CONSENT_COST_OBJECT_HISTORY.replace(
      ':consentId',
      String(consentId)
    ).replace(':costObjectId', String(costObjectId)),
    IS_NEW_BACKEND_API
  )
}
